import useBreadcrumbs from '@admin/hooks/useAdminBreadcrumbs';
import Button from '@shared/components/core/button/CoreButton';
import PageHeader from '@shared/components/core/headers/PageHeader';
import ProjectsPageContent from '@shared/components/organization/projects/ProjectsPageContent';
import useCurrentOrgDetailsFetching from '@shared/hooks/useCurrentOrgDetailsFetching';
import OrgPageTemplate from 'admin/components/organization/OrgPageTemplate';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

export default function ProjectsLandingPage() {
    const { t } = useTranslation();
    const { items } = useBreadcrumbs();
    const { isExpiredOrg, currentOrg } = useCurrentOrgDetailsFetching();
    const navigate = useNavigate();

    if (!currentOrg) return null;
    return (
        <OrgPageTemplate>
            <PageHeader
                title={currentOrg?.name + ' ' + t('common:organization.projects.title')}
                description={t('common:organization.projects.description')}
                items={items}>
                {!isExpiredOrg && (currentOrg.canCreateAuthClients || currentOrg.isDeveloperAccess) && (
                    <Button $color="secondary" startIcon="plus" onClick={() => navigate('new')}>
                        {t('common:organization.projects.create.title')}
                    </Button>
                )}
            </PageHeader>
            <ProjectsPageContent />
        </OrgPageTemplate>
    );
}
